module.exports = __webpack_public_path__ + "assets/img/star_sentence_select1.c6c87b80.png";